export const ReservationStatus = {
  Book: "Book",
  Modify: "Modify",
  Cancel: "Cancel",
  Pay: "Pay",
};
